export const vendors = [
  {
    id: 1,
    name: "Kumail",
    mobile: "1234567890",
    dob: "1998-05-12",
    address: "Lucknow",
    bankAccount: "SBI - 123456",
    photo: "https://media.istockphoto.com/id/1448167415/photo/smiling-indian-businessman-in-suit-and-glasses-with-laptop-near-office-building.jpg?s=612x612&w=0&k=20&c=vuUgcc-IlZewhnRm7yNOIuEfAvTnyJdMsPbnvkAnZjc=",

    paidAmount: 20000000,
    remainingAmount: 70000,

    tasks: {
      inProgress: 1,
      completed: 4,
      remaining: 1,
    },

    transactions: [
      {
        projectName: "Mall Project",
        job: "Electrical Work",
        amount: 50000,
        status: "Completed",
      },
      {
        projectName: "Office",
        job: "Lighting",
        amount: 30000,
        status: "In Progress",
      },
    ],
  },
   {
    id: 2,
    name: "Rehan bhai",
    mobile: "1234567890",
    dob: "1998-05-12",
    address: "Lucknow",
    bankAccount: "SBI - 123456",
    photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTy2ZZztV7o2ezJ8xmD2_gpehBKs9YF30jbmQ&s",

    paidAmount: 200000,
    remainingAmount: 50000,

    tasks: {
      inProgress: 1,
      completed: 4,
      remaining: 1,
    },

    transactions: [
      {
        projectName: "Mall Project",
        job: "Electrical Work",
        amount: 50000,
        status: "Completed",
      },
      {
        projectName: "Office",
        job: "Lighting",
        amount: 30000,
        status: "In Progress",
      },
    ],
  },
  {
    id: 3,
    name: "hasan",
    mobile: "1234567890",
    dob: "1998-05-12",
    address: "Lucknow",
    bankAccount: "SBI - 123456",
    photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2GO2tA-7CxTKdCo12hVL2JKuATwDf9R5Neg&s",

    paidAmount: 200000,
    remainingAmount: 50000,

    tasks: {
      inProgress: 15,
      completed: 1,
      remaining: 10,
    },

    transactions: [
      {
        projectName: "Mall Project",
        job: "Electrical Work",
        amount: 50000,
        status: "Completed",
      },
      {
        projectName: "Office",
        job: "Lighting",
        amount: 30000,
        status: "In Progress",
      },
    ],
  },
  {
    id: 4,
    name: "Bahar",
    mobile: "1234567890",
    dob: "1998-05-12",
    address: "Lucknow",
    bankAccount: "SBI - 123456",
    photo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJ3MhdaszRKFhv1qrpSU8U5sLdzhGDbHBBPg&s",

    paidAmount: 200000,
    remainingAmount: 50000,

    tasks: {
      inProgress: 9,
      completed: 2,
      remaining: 1,
    },

    transactions: [
      {
        projectName: "Mall Project",
        job: "Electrical Work",
        amount: 50000,
        status: "Completed",
      },
      {
        projectName: "Office",
        job: "Lighting",
        amount: 30000,
        status: "In Progress",
      },
    ],
  },
]
